import { useLogger } from '@vp/ubik-context'
import { useEffect, useState } from 'react'
import { FaqResult } from '../types/faq.type'

export const useFaqs = (articleNumbers: string[] | null | undefined, locale: string, tenant: string, useStaging?: boolean) => {
  const logger = useLogger()
  const [faqResults, setFaqResults] = useState<FaqResult[] | null>(null)
  const [isLoadingFaq, setIsLoadingFaq] = useState(false)
  const fetchFaq = async (id: string | null | undefined, hcServiceUrl: string): Promise<FaqResult | null> => {
    if (!id) {
      return null
    }
    try {
      const response = await fetch(`${hcServiceUrl}/v2/${tenant}/${locale}/articles/${id}?visible=false`)
      if (!response.ok) {
        logger.error(`Failed to fetch FAQ for id ${id}: ${response.status} ${response.statusText}`)
        return null
      }
      const data = await response.json()
      return {
        id: id,
        question: data.question,
        answer: data.articleBody,
      }
    } catch (err) {
      const error = err instanceof Error ? err : new Error(String(err))
      logger.error('Failed to fetch FAQ', { id, locale, tenant, error })
      return null
    }
  }

  const fetchFaqs = async (ids?: string[] | null): Promise<FaqResult[] | null> => {
    if (!ids || ids.length === 0) {
      return null
    }

    setIsLoadingFaq(true)
    const hcServiceUrl = useStaging ? 'HELP_CENTER_SERVICE_STAGING' : 'HELP_CENTER_SERVICE'
    const resultsPromise = await Promise.all(ids.map((id) => fetchFaq(id, hcServiceUrl)))
    const results = resultsPromise.filter((result): result is FaqResult => result !== null)
    setFaqResults(results.splice(0, 5))
    setIsLoadingFaq(false)
    return results
  }
  useEffect(() => {
    fetchFaqs(articleNumbers)
  }, [articleNumbers, locale, tenant, useStaging])

  return { faqResults, isLoadingFaq }
}
